import areaDlgMul from "./areaDlgMul.js";
import subjectDlgMul from "./subjectDlgMul.js";

const matterMan = {
  namespaced: true,
  modules: {
    areaDlgMul,
    subjectDlgMul
  }
};

export default matterMan;
